import { render, staticRenderFns } from "./SelfService.vue?vue&type=template&id=ca7f1e58&scoped=true"
import script from "./SelfService.vue?vue&type=script&lang=js"
export * from "./SelfService.vue?vue&type=script&lang=js"
import style0 from "../../assets/styles/inventory.css?vue&type=style&index=0&id=ca7f1e58&prod&scoped=true&lang=css&external"
import style1 from "./SelfService.vue?vue&type=style&index=1&id=ca7f1e58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7f1e58",
  null
  
)

export default component.exports